/*!
 * Copyright © 2018. Verizon Connect Ireland Limited. All rights reserved.
 */

export enum ESignalStatus {
  Normal = 'normal',
  Low = 'low',
  Lost = 'lost',
}
